import React from "react"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import FontIcon from "material-ui/FontIcon"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import PayrollTimeByHierarchyEmployeeRow from "./PayrollTimeByHierarchyEmployeeRow"
import { green500 } from "material-ui/styles/colors"
import { IDateRange, IPayrollTimeJob, ITimeTotals } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import UserCheck from "../../../../assets/icons/user-check"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
interface IProps {
    payrollDates: IDateRange
    payrollTimeJobs: IPayrollTimeJob[]
    timeTotals: ITimeTotals
    showTimecardPopup(employeeId: string, referenceDate: string): void
    reloadTimeCard : () => void
}
interface IState {
    expandRow: number
}

export default class PayrollTimeByJobTable extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            expandRow: -1,
        }
        autobind(this)
    }

    handleClickRow(clickedRow) {
        this.setState({
            expandRow: clickedRow === this.state.expandRow ? -1 : clickedRow
        })
    }

    getMissingPunchCount(jobData: IPayrollTimeJob) {
        let missingPunchCount = 0
        jobData.PayrollEmployees.forEach(employeeData => {
            employeeData.JobCostingSummaryList.forEach(dayData => {
                dayData.PayrollPunchSets.forEach((punchSet) => {
                    if (!punchSet.PunchOutId) missingPunchCount++
                })
            })
        })
        return missingPunchCount
    }

    render() {
        return (
            <Table multiSelectable={false} wrapperStyle={{ width: "fit-content", overflow: "unset" }}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn className="TextOverflow" title={ checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job} style={styles.hierarchyCol}>{checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job}</TableHeaderColumn>
                        <TableHeaderColumn className="TextOverflow" title={strings.External_ID} style={styles.hierarchyCol}>{strings.External_ID}</TableHeaderColumn>
                        <TableHeaderColumn className="TextOverflow" title={strings.Cost_Code} style={styles.hierarchyCol}>{strings.Cost_Code}</TableHeaderColumn>
                        <TableHeaderColumn className="TextOverflow" title={strings.Hierarchy} style={styles.hierarchyCol}>{strings.Hierarchy}</TableHeaderColumn>
                        <TableHeaderColumn />
                        <TableHeaderColumn className="TextOverflow" title={strings.TotalHours} style={styles.hoursCol}>{strings.TotalHours}</TableHeaderColumn>
                        <TableHeaderColumn className="TextOverflow" title={strings.Reg_Hours} style={styles.hoursCol}>{strings.Reg_Hours}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.hoursCol}>{strings.OT_Hours}</TableHeaderColumn>
                        {!AccountStore.getHideOT2() &&
                            <TableHeaderColumn className="TextOverflow" title={strings.OT2_Hours} style={styles.hoursCol}>{strings.OT2_Hours}</TableHeaderColumn>
                        }
                        {this.props.timeTotals.PayTypeTotals.map((payTypeTotal, index) =>
                            <TableHeaderColumn key={index} style={styles.hoursCol}>
                                <span className="TextOverflow" title={payTypeTotal.PayTypeName}>{payTypeTotal.PayTypeCode} </span>
                            </TableHeaderColumn>
                        )}
                        <TableHeaderColumn className="TextOverflow" title={strings.Open_Punches} style={styles.missingPunchedCol}>{strings.Open_Punches}</TableHeaderColumn>
                        {AccountStore.getEmployeeApproveTimecardEnabled() &&
                            <TableHeaderColumn className="TextOverflow" title={strings.Employee} style={styles.approveCol}>{strings.Employee}</TableHeaderColumn>
                        }
                        <TableHeaderColumn className="TextOverflow" title={strings.Supervisor} style={styles.approveCol}>{strings.Supervisor}</TableHeaderColumn>
                        {AccountStore.getExtSupApproveTimecardEnabled() &&
                            <TableHeaderColumn className="TextOverflow" title={strings.External} style={styles.approveCol}>{strings.External}</TableHeaderColumn>
                        }
                    </TableRow>
                </TableHeader>
                <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                    {this.props.payrollTimeJobs.map((jobData, index) => {
                        const expandState = index === this.state.expandRow
                        return (
                            <TableRow key={index}>
                                <TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <Table style={{ backgroundColor: "none" }} onCellClick={() => this.handleClickRow(index)}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow data-intercom-target={index === 0 && "menu-Payroll-PayrollTimeJobTable-openItemDetails"} style={{ cursor: "pointer", height: 48, borderBottom: expandState ? "solid 2px #cccccc" : "none" }}>
                                                <TableRowColumn style={styles.hierarchyCol} title={jobData.JobName}>{jobData.JobName ? jobData.JobName : checkJobFieldAvailable('singular')  ?  `No ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}`:strings.No_Job}</TableRowColumn>
                                                <TableRowColumn style={styles.hierarchyCol}>{jobData.JobExternalId}</TableRowColumn>
                                                <TableRowColumn style={styles.hierarchyCol}>{jobData.JobCostCode}</TableRowColumn>
                                                <TableRowColumn style={styles.hierarchyCol}>{jobData.HierarchyName}</TableRowColumn>
                                                <TableRowColumn />
                                                <TableRowColumn style={styles.hoursCol}>{jobData.TimeTotals && jobData.TimeTotals.TotalProductiveHours}</TableRowColumn>
                                                <TableRowColumn style={styles.hoursCol}>{jobData.TimeTotals && jobData.TimeTotals.RegularHours}</TableRowColumn>
                                                <TableRowColumn style={styles.hoursCol}>{jobData.TimeTotals && jobData.TimeTotals.OvertimeHours}</TableRowColumn>
                                                {!AccountStore.getHideOT2() &&
                                                    <TableRowColumn style={styles.hoursCol}>{jobData.TimeTotals && jobData.TimeTotals.DoubleOvertimeHours}</TableRowColumn>
                                                }
                                                {this.props.timeTotals.PayTypeTotals.map((payTypeTotalType, index) => {
                                                    const payTypeTotal = jobData.TimeTotals.PayTypeTotals.find(payType => payType.PayTypeId === payTypeTotalType.PayTypeId)
                                                    return (
                                                        <TableRowColumn style={styles.hoursCol} key={index}>{payTypeTotal && payTypeTotal.TotalHours}</TableRowColumn>
                                                    )
                                                })}
                                                <TableRowColumn style={styles.missingPunchedCol}>{this.getMissingPunchCount(jobData)}</TableRowColumn>
                                                {AccountStore.getEmployeeApproveTimecardEnabled() &&
                                                    <TableRowColumn style={styles.approveCol}>
                                                        {jobData.TotalEmployees === (jobData.TotalEmpApprovedEmployees) &&
                                                            <UserCheck color={green500} width={17.5} height={14} />
                                                        }
                                                    </TableRowColumn>
                                                }
                                                <TableRowColumn style={styles.approveCol}>
                                                    {jobData.TotalApprovedEmployees === (jobData.TotalEmployees) &&
                                                        <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                                                    }
                                                </TableRowColumn>
                                                {AccountStore.getExtSupApproveTimecardEnabled() &&
                                                    <TableRowColumn style={styles.approveCol}>
                                                        {jobData.TotalEmployees === (jobData.TotalExtSupApprovedEmployees) &&
                                                            <FontIcon className="fa fa-check-double" style={{ fontSize: 14, color: green500 }} />
                                                        }
                                                    </TableRowColumn>
                                                }
                                            </TableRow>
                                            <TableRow style={{ height: expandState ? 48 : 0 }}>
                                                <TableRowColumn
                                                    colSpan={10 +
                                                        (AccountStore.getHideOT2() ? 0 : 1) +
                                                        (this.props.timeTotals && this.props.timeTotals.PayTypeTotals ? this.props.timeTotals.PayTypeTotals.length : 0) +
                                                        (AccountStore.getEmployeeApproveTimecardEnabled() ? 1 : 0) +
                                                        (AccountStore.getExtSupApproveTimecardEnabled() ? 1 : 0)
                                                    }
                                                    style={{ height: expandState ? 48 : 0, padding: expandState ? "50px 0px 50px 50px" : 0 }}
                                                >
                                                    <div onClick={(e) => e.stopPropagation()}>
                                                        <PayrollTimeByHierarchyEmployeeRow
                                                            viewPayrollByJob
                                                            payrollDates={this.props.payrollDates}
                                                            employees={jobData.PayrollEmployees}
                                                            timeTotals={jobData.TimeTotals}
                                                            showTimecardPopup={this.props.showTimecardPopup}
                                                            expandState={expandState}
                                                            payrollHierarchyIndex={index}
                                                            reloadTimeCard={this.props.reloadTimeCard}
                                                        />
                                                    </div>
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        )
    }
}

const styles = {
    hierarchyCol: {
        width: 100,
        paddingLeft: 10,
        paddingRight: 10
    },
    hoursCol: {
        width: 60,
        paddingLeft: 5,
        paddingRight: 5
    },
    approveCol: {
        width: 70,
        textAlign: "center",
        paddingLeft: 5,
        paddingRight: 5
    },
    missingPunchedCol: {
        width: 80,
        paddingLeft: 5,
        paddingRight: 5
    }
}
